import {Injectable} from '@angular/core';
import {Breadcrumb, BreadcrumbItem} from '../../../types/Breadcrumb';

@Injectable()
export class SearchBreadcrumbsService {
  constructor() {}

  public getBreadcrumbs(breadcrumbs: BreadcrumbItem[]): Breadcrumb[] {
    return breadcrumbs.map((breadcrumb) => ({
      anchor: breadcrumb.name,
      routeParams: [breadcrumb.url],
      routeQueryParams: null,
    }));
  }
}
